import script from "./SchemaSnapshot.vue?vue&type=script&setup=true&lang=js"
export * from "./SchemaSnapshot.vue?vue&type=script&setup=true&lang=js"

import "./SchemaSnapshot.vue?vue&type=style&index=0&id=7b3fadc7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b3fadc7"]])

export default __exports__